import { render } from "./SingleBlog.vue?vue&type=template&id=5c17ab47&scoped=true"
import script from "./SingleBlog.vue?vue&type=script&lang=js"
export * from "./SingleBlog.vue?vue&type=script&lang=js"

import "./SingleBlog.vue?vue&type=style&index=0&id=5c17ab47&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c17ab47"]])

export default __exports__